/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} SummaryInputs */

const en_summary = /** @type {(inputs: SummaryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Summary`)
};

const de_summary = /** @type {(inputs: SummaryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zusammenfassung`)
};

/**
* | output |
* | --- |
* | "Summary" |
*
* @param {SummaryInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const summary = /** @type {((inputs?: SummaryInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<SummaryInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_summary(inputs)
	return en_summary(inputs)
});